import React, { useMemo } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { AppPageLoader } from "./AppPageLoader";
import { useSession } from "./SessionContext";

export const GuestOnlyRoute: React.FC = () => {
  const {
    isAuthenticated,
    authResolved,
    bootLoading,
    authStatus,
    telegramLaunchContext,
  } = useSession();

  const loaderText = useMemo(() => {
    if (
      telegramLaunchContext.isLikelyTelegram &&
      authStatus === "telegram_reauthenticating"
    ) {
      return "\u0412\u043e\u0441\u0441\u0442\u0430\u043d\u0430\u0432\u043b\u0438\u0432\u0430\u0435\u043c \u0441\u0435\u0441\u0441\u0438\u044e Telegram...";
    }

    if (
      telegramLaunchContext.isLikelyTelegram &&
      (authStatus === "bootstrapping" ||
        authStatus === "telegram_authenticating")
    ) {
      return "\u0412\u0445\u043e\u0434 \u0447\u0435\u0440\u0435\u0437 Telegram...";
    }

    return "\u041f\u043e\u0434\u043a\u043b\u044e\u0447\u0435\u043d\u0438\u0435...";
  }, [authStatus, telegramLaunchContext.isLikelyTelegram]);

  if (!authResolved || bootLoading) {
    return <AppPageLoader text={loaderText} />;
  }

  if (isAuthenticated) {
    return <Navigate to="/main" replace />;
  }

  return <Outlet />;
};
